import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Tick: FC<IconProps> = (props) => (
  <Icon {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0-3h32v32H0z" />
      <path
        fill="currentColor"
        d="m10.869 24.072-10.4-10.4a1.6 1.6 0 0 1 0-2.263L2.73 9.146a1.6 1.6 0 0 1 2.263 0L12 16.152 27.006 1.146a1.6 1.6 0 0 1 2.263 0l2.262 2.263a1.6 1.6 0 0 1 0 2.263l-18.4 18.4a1.6 1.6 0 0 1-2.262 0Z"
      />
    </g>
  </Icon>
);
